// removed by extract-text-webpack-plugin
module.exports = {"container":"_2H2sj2zw5D3I5DjIqlC_Wp","routes":"_1gkFCbBan3x21KdRQB5XW-"};


//////////////////
// WEBPACK FOOTER
// ./src/App/Pages/Preparation/SSContract/styles.css
// module id = 3247
// module chunks = 0